module.exports = __webpack_public_path__ + "static/img/faq-1.978d7f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/faq-1.png
// module id = HNBt
// module chunks = 4